/**
 * Default application theme (colors + breakpoints).
 * Single source used by ThemeProvider in `src/index.tsx` and the style guide tokens.
 */
export const defaultAppTheme = {
  typography: {},
  breakpoints: {
    mobile: `${360 / 16}rem`,
    mobileXs: `${475 / 16}rem`,
    mobileSm: `${640 / 16}rem`,
    tablet: `${724 / 16}rem`,
    tabletLg: `${1024 / 16}rem`,
    desktop: `${1080 / 16}rem`,
    desktopXl: `${1280 / 16}rem`,
    desktopTxl: `${1536 / 16}rem`,
  },
  palette: {
    primary: {
      blue50: "hsl(219, 71%, 97%)",
      blue100: "rgb(210, 227, 255)",
      blue200: "rgb(188, 214, 255)",
      blue300: "rgb(158, 195, 255)",
      blue400: "rgb(139, 184, 255)",
      blue500: "hsl(217 100% 72%)",
      blue550: "rgb(114, 197, 245)",
      blue600: "rgb(100, 151, 232)",
      blue700: "rgb(78, 118, 181)",
      blue800: "rgb(61, 91, 140)",
      blue900: "hsl(216, 40%, 30%)",
    },
    secondary: {
      orange50: "rgb(252, 240, 235)",
      orange100: "rgb(244, 207, 193)",
      orange200: "rgb(239, 184, 163)",
      orange300: "rgb(232, 152, 120)",
      orange400: "rgb(228, 132, 94)",
      orange500: "hsl(17 71% 54%)",
      orange600: "rgb(201, 92, 49)",
      orange700: "rgb(157, 72, 38)",
      orange800: "rgb(122, 56, 30)",
      orange900: "rgb(93, 42, 23)",
    },
    greyscale: {
      grey50: "rgb(240, 240, 240)",
      grey100: "rgb(208, 208, 208)",
      grey200: "hsl(0 0 73%)",
      grey300: "hsl(0 0 60%)",
      grey400: "rgb(133, 133, 133)",
      grey500: "rgb(102, 102, 102)",
      grey600: "hsl(0, 0%, 36%)",
      grey700: "hsl(0 0% 28%)",
      grey800: "hsl(0 0% 22%)",
      grey900: "rgb(43, 43, 43)",
    },
    black: {
      default: "hsl(232 17% 7%)",
    },
    error: {
      red: "#FF3838",
    },
  },
} as const;

export type DefaultAppTheme = typeof defaultAppTheme;
